export default "__VITE_ASSET__7174a524__"